
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCusAgingDialog extends Serenity.EntityDialog<ReportCusAgingRow, any> {
        protected getFormKey() { return ReportCusAgingForm.formKey; }
        protected getIdProperty() { return ReportCusAgingRow.idProperty; }
        protected getLocalTextPrefix() { return ReportCusAgingRow.localTextPrefix; }
        protected getNameProperty() { return ReportCusAgingRow.nameProperty; }
        protected getService() { return ReportCusAgingService.baseUrl; }
        protected getDeletePermission() { return ReportCusAgingRow.deletePermission; }
        protected getInsertPermission() { return ReportCusAgingRow.insertPermission; }
        protected getUpdatePermission() { return ReportCusAgingRow.updatePermission; }

        protected form = new ReportCusAgingForm(this.idPrefix);

    }
}